//@flow
import React, { PureComponent } from "react";
import Actions from "./actions";
//import Dropzone from 'react-dropzone'

import TranslateIcon from 'material-ui-icons/Translate';

function toPoints(vs) {
  return vs.map(v => [v.x || 0, v.y || 0].join(",")).join(" ");
}

export default class LiveImage extends PureComponent<
  {
    imgData: ?string,
    annotations: ?Array<any>,
    targetLang: string,
    originalLang: string,
    translatedText: string
  },
  *
> {
  state = {
    mouseDown: false,
    selX: 0,
    selY: 0,
    selW: 0,
    selH: 0,
    originalText: ""
    };

  img=null;
    
  
  getPoint = (e : MouseEvent|TouchEvent) => {
    var img = this.img;
    var rect = e.currentTarget.getBoundingClientRect();
    if (e.touches) e = e.touches[0];
    var pt = [
      (e.clientX - rect.left) * img.naturalWidth / img.width,
      (e.clientY - rect.top) * img.naturalHeight / img.height
    ];
    return pt;
  }
    onMouseDown = (e: MouseEvent) => {
      e.preventDefault();
      if (e.buttons > 1) return;

      var pt = this.getPoint(e);
      var selX = pt[0];
      var selY = pt[1];
      this.setState({ selX, selY, mouseDown: true, originalText: "" });
      Actions.clearTranslation();
  };
  onMouseUp =   (e: MouseEvent) => {
    e.preventDefault();
    var img = this.img;

    var pt = this.getPoint(e);
    var selX = pt[0];
    var selY = pt[1];

    this.setState({
      selW: selX - this.state.selX,
      selH: selY - this.state.selY
    });
    this.translateIt();
    };
onMouseMove = (e: MouseEvent) => {
  e.preventDefault();
  if (e.buttons === 0) return;
  if (!this.state.mouseDown) return;

  var pt = this.getPoint(e);
  var selX = pt[0];
  var selY = pt[1];
  this.setState({
    selW: selX - this.state.selX,
    selH: selY - this.state.selY
  });
  }; 
  onTouchStart = (e: TouchEvent) => {
    e.preventDefault();
    var pt = this.getPoint(e);
    var selX = pt[0];
    var selY = pt[1];
    this.setState({ selX, selY, selW:0, selH:0, mouseDown: true, originalText: "" });
    Actions.clearTranslation();
    };    
    onTouchMove = (e: TouchEvent) => {
      e.preventDefault();
      var pt = this.getPoint(e);
      var selX = pt[0];
      var selY = pt[1];
      this.setState({
        selW: selX - this.state.selX,
        selH: selY - this.state.selY
      });
  };   
  onTouchEnd =  (e: TouchEvent) => {
    this.translateIt();
    };
  
  translateIt = () => {
    if (!this.props.annotations) return;
    var txt = this.getSelectedText();
    if (window.ga) window.ga("send", "event", "img", "selection", "" + txt);
    this.setState({ mouseDown: false, originalText: txt });
    if (txt)
      Actions.translateAction(
        this.props.targetLang,
        txt,
        this.props.originalLang
      );
  };

  getSelectedText = () => {
    const rect_overlap = (r1, r2) =>
      !(
        r2.x > r1.x + r1.width ||
        r2.x + r2.width < r1.x ||
        r2.y > r1.y + r1.height ||
        r2.y + r2.height < r1.y
      );
    const isInSelection = vertices => {
      return rect_overlap(
        {
          x: Math.min(this.state.selX, this.state.selX + this.state.selW),
          y: Math.min(this.state.selY, this.state.selY + this.state.selH),
          width: Math.abs(this.state.selW),
          height: Math.abs(this.state.selH)
        },
        {
          x: vertices.map(v => v.x||0).reduce((a, b) => Math.min(a, b), Infinity),
          y: vertices.map(v => v.y||0).reduce((a, b) => Math.min(a, b), Infinity),
          width:
            vertices.map(v => v.x||0).reduce((a, b) => Math.max(a, b), -Infinity) -
            vertices.map(v => v.x||0).reduce((a, b) => Math.min(a, b), Infinity),
          height:
            vertices.map(v => v.y||0).reduce((a, b) => Math.max(a, b), -Infinity) -
            vertices.map(v => v.y||0).reduce((a, b) => Math.min(a, b), Infinity)
        }
      );
    };
    if (!this.props.annotations) return '';
    return this.props.annotations
      .slice(1)
      .filter(a => isInSelection(a.boundingPoly.vertices))
      .map(a => a.description)
      .join(" ");
  };

  componentDidMount() {
    // TODO: string refs
    this.refs.container.ontouchstart = (e) => e.preventDefault();
    this.refs.container.ontouchmove = (e) => e.preventDefault();
  }

  componentDidUpdate() {
    var img = this.img;
    var svg = this.refs.svg;
    var scaler = this.refs.scaler;

    svg.setAttribute("width", img.naturalWidth);
    svg.setAttribute("height", img.naturalHeight);
    svg.setAttribute(
      "viewBox",
      "0 0 " + img.naturalWidth + " " + img.naturalHeight
    );
    scaler.style.transform = "scale(" + img.width / img.naturalWidth + ")";
    scaler.style.fontSize = 12 / (img.width / img.naturalWidth) + "px";
  }

  render() {
    return (
      <div ref="container" className="live-image preview"
        onMouseUp={this.onMouseUp}
        onMouseDown={this.onMouseDown}
        onMouseMove={this.onMouseMove}
        onTouchStart={this.onTouchStart}
        onTouchMove={this.onTouchMove}
        onTouchEnd={this.onTouchEnd}

      >
        {this.props.annotations && this.props.annotations.length == 0 && <p>No text found in image. Try using "Detect Language" and make sure the text is not blurry or handwritten.</p>}
        <svg
          ref="svg"
          width="1000"
          height="1000"
          preserveAspectRatio="xMinYMin"
        >
          {this.props.annotations &&
            this.props.annotations
              .slice(1)
              .map( (a,i) => (
                <polygon
                  key={i}  
                  points={toPoints(a.boundingPoly.vertices)}
                  title={a.description}
                />
              ))}
          <rect
            className="selection"
            x={Math.min(this.state.selX, this.state.selX + this.state.selW)}
            y={Math.min(this.state.selY, this.state.selY + this.state.selH)}
            width={Math.abs(this.state.selW)}
            height={Math.abs(this.state.selH)}
          />
        </svg>
        <img
          ref={(el) => this.img = el}
          alt=""
          className={this.props.imgData ? "valid" : "invalid "}
          src={
            this.props.imgData && "data:image/png;base64," + this.props.imgData
          }
        />
        <div ref="scaler" className="translated-scaler">
          {!this.state.mouseDown && (
            <div
              className="translated-text"
              style={{
                left: Math.min(
                  this.state.selX,
                  this.state.selX + this.state.selW
                ),
                top: Math.min(
                  this.state.selY,
                  this.state.selY + this.state.selH
                ),
                width: Math.abs(this.state.selW)
              }}
            >
              {this.props.translatedText || this.state.originalText}
              <a onMouseDown={
                (event) => event.stopPropagation()
              }
              onTouchStart={
                (event) => event.stopPropagation()
              }  


                target='_blank' className='open-google' title='Open in Google Translate' href={'http://translate.google.com/#' + [this.props.originalLang.replace('_detect', 'auto'), this.props.targetLang, this.state.originalText].map(encodeURIComponent).join('/')}><TranslateIcon /></a>
            </div>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/LiveImage.js